import { createContext } from "react";
import Client from "@igloocloud/igloo.js";

export default createContext(new Client());
